module.exports = __webpack_public_path__ + "img/img006.d1413cf0.png";